module.exports = __webpack_public_path__ + "img/da24a94.jpg";